import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';
import Modal from '../../modals/PopupModal';
import '../../css/Login.css';
import { ThemeContext } from '../../utils/ThemeProvider';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            if (!process.env.REACT_APP_BASE_URL) {
                console.error('BASE_URL environment variable is not set');
                setError('Server configuration error. Please contact support.');
                setShowModal(true);
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ email, password }),
            });

            let data;
            try {
                const textResponse = await response.text();
                try {
                    data = JSON.parse(textResponse);
                } catch (parseError) {
                    console.error('Error parsing response:', parseError, 'Response text:', textResponse);
                    throw new Error('Invalid response from server');
                }
            } catch (parseError) {
                console.error('Error reading response:', parseError);
                throw new Error('Could not read server response');
            }

            if (!response.ok) {
                console.error('Login failed:', {
                    status: response.status,
                    statusText: response.statusText,
                    data
                });
                throw new Error(data?.error || 'Login failed');
            }

            // Check if we have the required data
            if (data.token && data.user && data.user.email) {
                // If role is not provided, default to 'user'
                const userRole = data.user.role || 'user';
                login({ 
                    token: data.token, 
                    role: userRole,
                    user: {
                        ...data.user,
                        role: userRole
                    }
                });
                navigate('/home');
            } else {
                console.error('Invalid login response:', data);
                throw new Error(data.error || 'Invalid credentials');
            }
        } catch (error) {
            console.error('Error during login:', error);
            setError(error.message || 'Failed to login. Please try again.');
            setShowModal(true);
        } finally {
            setIsLoading(false);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setError('');
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Welcome Back</h2>
                <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="login-button" disabled={isLoading}>
                    {isLoading ? 'Logging in...' : 'Login'}
                </button>
            </form>
            <Modal show={showModal} message={error} onClose={closeModal} />
        </div>
    );
};

export default Login;
